import { Link } from "react-router-dom";
import Header from "../components/Header";

const AboutUs = () => {
    const featuresok = [
  {
    id: "01",
    title: "Hassle-Free Benefits",
    description:
      "Instant access to doctors, diagnostics, treatments and wellness services with zero paperwork.",
    image: "/assets/images/hassel-free.svg",
  },
  {
    id: "02",
    title: "Save on Daily Care",
    description:
      "Reduce consultation, pharmacy and diagnostic costs with affordable OPD plans.",
    image: "/assets/images/daily-care.svg",
  },
  {
    id: "03",
    title: "India's Wellness Network",
    description:
      "Access hospitals, clinics and labs across India through our trusted healthcare network.",
    image: "/assets/images/india-circle.svg",
  },
  {
    id: "04",
    title: "Quick & Easy Start",
    description:
      "Join in minutes with a simple online process and start using your healthcare benefits immediately.",
    image: "/assets/images/fast-and-simple-claim.svg",
  },
];
  return (
    <>
    <Header/>
      <section className="relative overflow-hidden bg-hero py-32 md:py-32 lg:py-48">
        {/* Background Glow */}
        <div className="absolute left-0 top-0 h-[450px] w-[450px] rounded-full bg-[#D4CB2F]/10 blur-[140px]" />
        <div className="absolute right-0 bottom-0 h-[450px] w-[450px] rounded-full bg-[#D4CB2F]/10 blur-[160px]" />

        <div className="theme-container relative z-10 mx-auto">
          {/* Heading */}
          <div className="mx-auto max-w-4xl text-center">
            <span
              // data-aos="fade-up"
              className="
        inline-flex
        items-center
        rounded-full
        border
        border-[#D4CB2F40]
        bg-[#D4CB2F]/10
        px-4
        py-1.5
        md:px-6
        md:py-2
        text-[11px]
        md:text-sm
        font-semibold
        uppercase
        tracking-[4px]
        text-[#D4CB2F]
      "
            >
              About Us
            </span>

            <h2
              // data-aos="fade-up"
              // data-aos-delay="100"
              className="mt-5
        md:mt-8
        text-2xl
        md:text-4xl
        font-black
        leading-tight
        text-white
        sm:text-5xl
        lg:text-6xl
      "
            >
              Bringing Healthcare
              <br />
              <span className="text-[#D4CB2F]">Closer To Every Family</span>
            </h2>

            <p
              // data-aos="fade-up"
              // data-aos-delay="200"
              className="
        mx-auto
        mt-5
        md:mt-8
        max-w-3xl
        text-[15px]
        md:text-lg
        leading-8
        text-gray-300
      "
            >
              At <span className="font-semibold text-white">S.Meera Health</span>, we
              make quality healthcare simple, affordable and accessible. Our
              digital healthcare ecosystem connects patients with trusted
              doctors, diagnostics, pharmacies and wellness services— all from
              one secure platform.
            </p>
          </div>

          {/* Feature Cards */}
          <Link to="/plans">
            <div
              // data-aos="fade-up"
              // data-aos-delay="400"
              className="mt-10 md:mt-16 flex justify-center"
            >
              <button
                className="group inline-flex items-center gap-3 rounded-full px-6 py-3 text-[14px] md:text-[16px] md:px-8 md:py-4 font-semibold text-white transition-all duration-300 hover:-translate-y-1"
                style={{
                  background: "linear-gradient(90deg,#D4CB2F 0%,#55534F 100%)",
                  boxShadow: "0 10px 35px rgba(212,203,47,0.25)",
                }}
              >
                Explore Plans
                <span className="transition-all duration-300 group-hover:translate-x-2">
                  →
                </span>
              </button>
            </div>
          </Link>
        </div>
      </section>

      <section className="pt-16">
        <div className="theme-container mx-auto flex flex-col items-center">
          <h1
            // data-aos="fade"
            className="inline-flex items-center gap-3 rounded-full border border-[#D4CB2F]/30 bg-[#D4CB2F]/10 px-3 py-2 md:px-4 md:py-2.5 text-[12px] md:text-[14px]"
          >
            What We Provide
          </h1>
          <h2
            // data-aos="fade"
            // data-aos-delay={100}
            className="text-main-black pt-5 max-w-[692px] text-center mt-4
                text-3xl
                md:text-4xl
                lg:text-5xl
                font-extrabold
                leading-tight"
          >
            Pathways to Progress: <p className="block text-[#D4CB2F]">Our Mission, Vision, and Goals</p>
          </h2>
        </div>
        {/* services */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5 md:gap-8 py-12 md:py-20 w-[80%] mx-auto">
          {featuresok.map((feature) => (
            <div
              key={feature.id}
              className="group relative overflow-hidden rounded-[30px] border border-[#D4CB2F]/20 bg-[#F8F8F5] p-6 md:p-8 transition-all duration-500 hover:-translate-y-3 hover:shadow-[0_25px_60px_rgba(212,203,47,.18)]"
            >
              {/* Animated Background */}
              <div className="absolute inset-x-0 bottom-0 h-0 bg-gradient-to-br from-[#D4CB2F] via-[#C4BC2B] to-[#55534F] transition-all duration-700 group-hover:h-full z-0" />

              {/* Number */}
              <span className="absolute right-6 top-4 text-[60px] md:text-[90px] font-black text-[#4a4702c7] z-10">
                {feature.id}
              </span>

              <div className="relative z-20">
                {/* Icon */}
                {/* <div className="flex md:h-16 w-14 h-14 md:w-16 items-center justify-center rounded-2xl bg-[#D4CB2F]/10 border border-[#D4CB2F]/20 text-[#D4CB2F] transition-all duration-500 group-hover:bg-white group-hover:scale-110">
                  <svg
                    className="h-8 w-8"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 3l8 4v5c0 5-3.5 8-8 9-4.5-1-8-4-8-9V7l8-4z" />
                  </svg>
                </div> */}
                <div className="flex md:h-16 md:w-16 h-14 w-14 items-center justify-center rounded-2xl bg-[#D4CB2F]/10 border border-[#D4CB2F]/20 transition-all duration-500 group-hover:bg-white group-hover:scale-110">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="h-8 w-8 md:h-10 md:w-10 object-contain transition-all duration-500"
                  />
                </div>

                <h3 className="mt-5 md:mt-8 text-lg md:text-2xl font-bold text-[#3F3D3A] transition-all duration-500 group-hover:text-white">
                  {feature.title}
                </h3>

                <p className="mt-3 md:mt-5 leading-6 md:leading-8 text-[#666] transition-all duration-500 group-hover:text-white/90">
                  {feature.description}
                </p>

                <div className="mt-4 md:mt-8 h-[3px] w-14 rounded-full bg-[#D4CB2F] transition-all duration-500 group-hover:w-24 group-hover:bg-white" />
              </div>
            </div>
          ))}
        </div>
      </section>
      <section className="py-16 md:py-24 px-4">
        <div
          className="
            relative
            max-w-7xl
            mx-auto
            overflow-hidden
            rounded-[40px]
            border
            bg-gradient-to-br
            from-[#8e8e40]
            to-[#5c5613]
            shadow-[0_20px_60px_rgba(212,203,47,0.12)]
          "
        >
          {/* Decorative Blur */}
          <div className="absolute -top-20 -left-20 h-56 w-56 rounded-full bg-[#D4CB2F]/10 blur-3xl" />
          <div className="absolute -bottom-20 -right-20 h-64 w-64 rounded-full bg-[#D4CB2F]/10 blur-3xl" />

          <div className="relative z-10 px-6 py-12 sm:px-10 md:px-16 lg:px-20 lg:py-16">
            <div className="grid lg:grid-cols-[1fr_auto] gap-10 lg:gap-16 items-center">
              {/* Content */}
              <div>
                <span
                  className="
                    inline-flex
                    items-center
                    rounded-full
                    border
                    border-[#D4CB2F]/30
                    bg-white/60
                    px-3
                    py-1.5
                    font-semibold
                    uppercase
                    tracking-[3px]
                    text-black
                    backdrop-blur-sm
                     gap-3 md:px-4 md:py-2.5 text-[12px] md:text-[14px]
                  "
                >
                  Healthcare Made Simple
                </span>

                <h2
                  className="mt-3
                    md:mt-5
                    text-2xl
                    sm:text-4xl
                    md:text-5xl
                    lg:text-6xl
                    font-bold
                    leading-tight
                    text-[#3F3D3A]
                  "
                >
                  Your Health,
                  <span className="block text-[#D4CB2F]">Our Priority</span>
                </h2>

                <p
                  className="
                    mt-4 md:mt-6
                    max-w-2xl
                    text-[14px]
                    sm:text-base
                    md:text-lg
                    leading-6 md:leading-8
                    text-white
                  "
                >
                  Affordable healthcare plans designed for individuals and
                  families with trusted support, wellness benefits, and complete
                  peace of mind. Access quality care whenever you need it
                  through our seamless digital healthcare platform.
                </p>
              </div>

              {/* CTA */}
              <div className="flex lg:justify-end">
                <Link
                  to="/plans"
                  className="group inline-flex items-center gap-3 rounded-full px-6 py-3 text-[14px] md:text-[16px] md:px-8 md:py-4 font-semibold text-white transition-all duration-300 hover:-translate-y-1 bg-[#D4CB2F]"
                >
                  <span>Explore Plans</span>

                  <svg
                    className="transition-transform duration-300 group-hover:translate-x-1"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M4 10H16"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                    <path
                      d="M10 4L16 10L10 16"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default AboutUs;
